export default {
    new: 'green',
    existing: 'orange'
};